<template>
  <article v-if="blog" class="overflow-hidden border-r-12" id="weblogCard">
    <router-link
      :to="{
        name: 'blogDetail',
        params: { id: blog.id },
        query: { slug: blog.slug },
      }"
    >
      <div>
        <img
          loading="lazy"
          class="w-100 h-100"
          v-if="blog.image"
          :src="blog.image.url"
          :alt="blog.title"
        />
      </div>
      <div class="w-100 bg-color-white py-4 px-3">
        <h3
          class="w-100 font-w-600 font-s-15 text-color-theme-dark text-right title-products-overflow"
        >
          {{ blog.title }}
        </h3>
        <div class="bg-color-theme7 py-2 px-3 border-r-4">
          <span
            v-if="blog.category"
            class="d-inline-block pr-2 font-w-400 font-s-10 text-color-theme-grey1 category"
            >{{ blog.category.name }}</span
          >
        </div>
        <p
          class="text-color-theme-grey2 font-w-400 font-s-10 line-height2 text-right pt-2"
        >
          {{ blog.summary }}
        </p>
        <div
          class="d-flex align-items-center justify-content-between flex-wrap pt-2 border-top"
        >
          <div
            class="d-flex align-items-center gap-5 py-1 px-2 bg-color-theme7 border-r-4 mt-1"
          >
            <span class="font-w-400 font-s-10 text-color-theme-grey1">{{
              blog.created_at | Date
            }}</span>
            <span><CalendarIcon /></span>
          </div>

          <div
            class="d-flex align-items-center gap-5 py-1 px-2 bg-color-theme7 border-r-4 mt-1"
          >
            <span class="font-w-400 font-s-10 text-color-theme-grey1">{{
              blog.comments_count
            }}</span>
            <span><CommentIcon /></span>
          </div>
          <div
            class="d-flex align-items-center gap-5 py-1 px-2 bg-color-theme7 border-r-4 mt-1"
          >
            <span class="font-w-400 font-s-10 text-color-theme-grey1"
              >توسط ادمین</span
            >
            <span><UserIcon /></span>
          </div>
        </div>
      </div>
    </router-link>
  </article>
</template>
<script>
import UserIcon from "@/parts/Front/components/Icon/User.vue";
import CommentIcon from "@/parts/Front/components/Icon/Comment.vue";
import CalendarIcon from "@/parts/Front/components/Icon/Calendar.vue";
export default {
  components: {
    UserIcon,
    CommentIcon,
    CalendarIcon,
  },
  props: {
    blog: {
      type: Object,
    },
  },
};
</script>
<style scoped>
#weblogCard {
  /* box-shadow: 0px 0px 37px 5px #bababa63; */
}
#weblogCard .category {
  border-right: 2px solid var(--color-theme);
}
#weblogCard .title-products-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
